import { render, staticRenderFns } from "./SithMesTpmProgramStatusTpsEdit.vue?vue&type=template&id=876e5afa&"
import script from "./SithMesTpmProgramStatusTpsEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesTpmProgramStatusTpsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports